import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Alert, Spinner } from 'react-bootstrap';
import { api } from './api';
import AuthCard from './AuthCard';
import { getSession } from './auth';

// The link in the email lands here and the page confirms it with a POST, so mail scanners that
// fetch links ahead of time can't use the one-time token up.
const VerifyEmail = ({ location }) => {
  const token = new URLSearchParams(location.search).get('t') || '';
  const [state, setState] = useState(token ? { status: 'working' } : { status: 'error', message: 'This link is incomplete.' });

  useEffect(() => {
    if (!token) return;
    let cancelled = false;
    api('verify-email', { token })
      .then(() => !cancelled && setState({ status: 'done' }))
      .catch((err) => !cancelled && setState({ status: 'error', message: err.message }));
    return () => { cancelled = true; };
  }, [token]);

  return (
    <AuthCard title="Verify your email">
      {state.status === 'working' && <div className="text-center"><Spinner animation="border" /></div>}
      {state.status === 'done' && <Alert variant="success">Your email is verified. You can now reset your password by email if you ever need to.</Alert>}
      {state.status === 'error' && (
        <Alert variant="danger">
          {state.message} {getSession() && <Link to="/profile">Request a new link from your profile.</Link>}
        </Alert>
      )}
      <div className="text-center"><Link to={getSession() ? '/user' : '/login'}>Continue</Link></div>
    </AuthCard>
  );
};

export default VerifyEmail;
